import { render, staticRenderFns } from "./SearchResources.vue?vue&type=template&id=c362e48c&scoped=true"
import script from "./SearchResources.vue?vue&type=script&lang=js"
export * from "./SearchResources.vue?vue&type=script&lang=js"
import style0 from "./SearchResources.vue?vue&type=style&index=0&id=c362e48c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c362e48c",
  null
  
)

export default component.exports